import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardEvaluaciones extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    download = (e) => {
        e.preventDefault();
        let name = e.target.parentNode.dataset.name;
        let url = e.target.parentNode.dataset.url;
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    };

    render() {

        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            {
                                this.props.roles.includes("DOCENTEGRADO,") ?
                                    <>
                                        <b>{this.props.objeto.descripcion}</b>
                                        <br />
                                        <br />
                                        <span className="spanCard">TIPO EVALUACIÓN: </span> {this.props.objeto.strTipo}
                                        <br />
                                    </>
                                    :
                                    null
                            }
                            <span className="spanCard">CALIFICACIÓN: </span> {this.props.roles.includes("DOCENTEGRADO,") ? this.props.objeto.calificacion + (this.props.objeto.calificacionmaxima ? "/" + this.props.objeto.calificacionmaxima : "") : this.props.objeto.puntaje + (this.props.objeto.calificacionmaxima ? "/" + this.props.objeto.calificacionmaxima : "")}
                            <br />
                            <span className="spanCard">FECHA EVALUACIÓN: </span> {this.parseDate(this.props.objeto.fechaevaluacion)}
                            <br />
                            <span className="spanCard">PERÍODO DESDE: </span> {this.props.roles.includes("DOCENTEGRADO,") ? this.parseDate(this.props.objeto.fechadesde) : this.parseDate(this.props.objeto.fechainicio)}
                            <br />
                            <span className="spanCard">PERÍODO HASTA: </span> {this.props.roles.includes("DOCENTEGRADO,") ? this.parseDate(this.props.objeto.fechahasta) : this.parseDate(this.props.objeto.fechafin)}
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            {
                                this.props.roles.includes("DOCENTEGRADO,") ?
                                    <FileDownload files={this.props.evidencias} card={true} icon="download" />
                                    :
                                    this.props.roles.includes("ADMINISTRATIVO,") ?
                                        this.props.evidencias.map((evidencia, idx) =>
                                            evidencia.name.includes("EV1") ?
                                                <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} key={idx} href="#"><i className="fas fa-downloadx" aria-hidden="true"></i></CardLink>
                                                :
                                                null
                                        )
                                        :
                                        null
                            }

                            {
                                this.props.roles.includes("DOCENTEGRADO,") ?
                                    <>
                                        <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                                        <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                                    </>
                                    :
                                    null
                            }

                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea eliminar el registro?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}